import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { InstrumentViewComponentBaseComponent } from '../../helpers/instrument-view-component-base.component';
import { EMEO_SAX_V1_INFO } from '../../model/instruments/emeo-sax-v1';
import { ConnectionService } from '../../services/connection.service';
import { InstrumentInfo } from '../../model/unc-types';

@Component({
  selector: 'app-emeo-saxophone-v1',
  templateUrl: './emeo-saxophone-v1.component.svg',
  styleUrls: ['./emeo-saxophone-v1.component.scss']
})
export class EmeoSaxophoneComponentV1 extends InstrumentViewComponentBaseComponent implements OnInit, OnDestroy {

  constructor(
    protected cs: ConnectionService,
    protected cd: ChangeDetectorRef) {

    super(cs,cd);
  }

  public get instrument() : InstrumentInfo {
    return EMEO_SAX_V1_INFO;
  }
}
